export class CandidateHiredDetails {
    salaryTypeId: number;
    salaryInUSDollars: number;
    salaryDescription: string;
    salaryIsRate: boolean;
    startDate?: Date;
    endDate?: Date;
    hoursPerWeek: number;
    duration?: string;
    terminationDate?: Date;
    canViewSalary: boolean;
    successFeeDescription: string;
}
